import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MultiGrid, AutoSizer } from 'react-virtualized';

import {
  columnCount,
  cellRenderer,
  getColumnWidthHelper,
  fixedRows,
  fixedColumns,
} from 'components/landlord_app/insights/helpers/cellRenderer.js';

const STYLE = {};

const STYLE_BOTTOM_LEFT_GRID = {};

const STYLE_TOP_LEFT_GRID = {
  borderBottom: '2px solid #4e4e4e',
  borderTop: '2px solid #4e4e4e',
};

const STYLE_TOP_RIGHT_GRID = {
  borderBottom: '2px solid #4e4e4e',
  borderTop: '2px solid #4e4e4e',
};

export default connect(store => {
  return {
    report: store.insights.reportData,
    dateRange: store.insights.dateRange,
    reportType: store.insights.reportType,
    propertyIds: store.insights.propertyIds,
  };
}, {})(
  class ReportingNonGrid extends Component {
    generalLedger = (isAccrual, transaction_ids = [], report_type, options) => {
      this.props.generateReport(
        isAccrual,
        this.props.dateRange,
        this.props.property_ids,
        transaction_ids,
        report_type,
        options
      );
    };

    calculateMaxWidth = (data, reportType) => {
      if (reportType === 'balance_sheet' || reportType === 'profit_loss') {
        return columnCount(data) <= 3 ? '700px' : 'inherit';
      }
      if (reportType === 'general_ledger') {
        return '1605px';
      }
      if (reportType === 'all_transactions') {
        return '1165px';
      }
      if (reportType === 'aged_receivables' || reportType === 'aged_payables') {
        return '1125px';
      }
      if (reportType === 'general_journal') {
        return '1090px';
      }
      if (reportType === 'vacancy_report') {
        return '1200px';
      }
      if (reportType === 'rent_roll') {
        return '1800px';
      }
      if (reportType === 'applications') {
        return '1425px';
      }
      if (reportType === 'showings') {
        return '2075px';
      }
      if (reportType === 'showings_book_date') {
        return '2075px';
      }
      if (reportType === 'leases') {
        return '2375px';
      }
      if (reportType === 'payments_report') {
        return '1240px';
      }
      if (reportType === 'deposits_report') {
        return '1300px';
      }
      if (reportType === 'ancillary_items') {
        return '1775px';
      }
      if (reportType === 'maintenance_tickets' || reportType === 'maintenance_log') {
        return '2500px';
      }
      if (reportType === 'capreit_tenant_name_change_report') {
        return '1800px';
      }
      if (reportType === 'resident_data_report' || reportType === 'lead_marketing_report') {
        return '1300px';
      }
      if (reportType === 'prospect_data_report') {
        return '2600px';
      }
    };

    render() {
      const data = this.props.data;
      const rowCount = data.length;
      const reportType = this.props.reportType;
      const numberOfColumns = columnCount(data);

      return (
        <div
          style={{
            height: '100%',
            marginTop: '20px',
            maxWidth: this.calculateMaxWidth(data, reportType),
            margin: 'auto',
          }}
        >
          <AutoSizer onResize={() => this.mainGrid.recomputeGridSize()}>
            {({ height, width }) => (
              <MultiGrid
                ref={grid => {
                  this.mainGrid = grid;
                }}
                cellRenderer={cellInfo => cellRenderer(cellInfo, data, reportType)}
                columnWidth={
                  numberOfColumns > 0 ? getColumnWidthHelper(width, reportType, numberOfColumns) : 0
                }
                rowHeight={({ index }) => (index === 0 ? 38 : 30)}
                columnCount={numberOfColumns}
                enableFixedColumnScroll
                enableFixedRowScroll
                height={height}
                rowCount={rowCount}
                fixedRowCount={fixedRows(reportType)}
                fixedColumnCount={fixedColumns(reportType)}
                style={STYLE}
                styleBottomLeftGrid={STYLE_BOTTOM_LEFT_GRID}
                styleTopLeftGrid={STYLE_TOP_LEFT_GRID}
                styleTopRightGrid={STYLE_TOP_RIGHT_GRID}
                width={width}
              />
            )}
          </AutoSizer>
        </div>
      );
    }
  }
);
